// eslint-disable-next-line no-restricted-imports
import { SvgIcon, SvgIconProps } from '@mui/material';
import Svg from '@rhg/../public/_n/images/icons/forward-15.svg';

export const Forward15 = (props: SvgIconProps) => (
    <SvgIcon component={Svg} inheritViewBox {...props} />
);
